// Centralized links and contact details for easy updates
// Update these values to your latest profiles and endpoints
import { sharedData } from './sharedData';

export const socialLinks = sharedData.socialLinks;

export const contactLinks = {
  emailAddress: sharedData.contact.email,
  emailHref: `mailto:${sharedData.contact.email}`,
  messengerHref: sharedData.socialLinks.facebook,
  whatsappNumber: sharedData.contact.phone,
  whatsappHref: `https://api.whatsapp.com/send?phone=${sharedData.contact.phone}`
};

// Portfolio items: update titles, images, and links as needed
// Keeping existing items but this structure is now configurable
export const portfolioItems = [
  // Example item structure for future updates
  // { id: 1, image: '', title: 'Project Title', github: '', demo: '' }
];


